"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.Breadcrumbs = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _BreadcrumbItem = require("./BreadcrumbItem");

var _Core = require("../Core");

var _class;

var Breadcrumbs = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Breadcrumbs, _Component);

  function Breadcrumbs(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = Breadcrumbs.prototype;

  _proto.render = function render() {
    var items = this.props.items;
    var homeItem = {
      label: "Home",
      to: "/"
    };
    return _react.default.createElement(_Core.Flex, {
      my: 3,
      flexWrap: "wrap"
    }, _react.default.createElement(_BreadcrumbItem.BreadcrumbItem, {
      label: homeItem.label,
      to: homeItem.to
    }), "\xA0", items.map(function (item) {
      return _react.default.createElement(_BreadcrumbItem.BreadcrumbItem, {
        key: item.label,
        label: item.label,
        to: item.to // separator={index ? ">" : ""}
        ,
        separator: ">"
      });
    }));
  };

  return Breadcrumbs;
}(_react.Component)) || _class;

exports.Breadcrumbs = Breadcrumbs;